import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getPendingOrdersApi } from './getPendingOrders.api'
import getPendingOrdersInitialState from './getPendingOrders.initialState'
import { GetPendingOrdersErrorResponse, GetPendingOrdersRequestPayload } from './getPendingOrders.types'

export const getPendingOrders = createAsyncThunk(
  urls.logisticsPartner.getPendingOrders,
  async (payload: GetPendingOrdersRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload || {}

    try {
      const response = await getPendingOrdersApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getPendingOrdersSlice = createSlice({
  name: urls.logisticsPartner.getPendingOrders,
  initialState: getPendingOrdersInitialState,
  reducers: {
    resetGetPendingOrders: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPendingOrders.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getPendingOrders.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getPendingOrders.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetPendingOrdersErrorResponse
        state.success = null
      })
  }
})

export const { actions: getPendingOrdersActions, reducer: getPendingOrdersReducer } = getPendingOrdersSlice
export const { resetGetPendingOrders } = getPendingOrdersActions
export default getPendingOrdersSlice.reducer
